import AOS from 'aos'
import 'aos/dist/aos.css'

// Mark the document ready as soon as this module runs. The CSS fail-safe
// (html:not(.aos-ready) [data-aos] { opacity: 1 }) keeps every block visible
// when the bundle never executes (JS disabled / build missing), so content is
// never permanently hidden behind AOS's opacity:0 default.
document.documentElement.classList.add('aos-ready')

AOS.init({
  once: true,                 // animate the first time a block enters the viewport, then leave it
  duration: 700,
  offset: 80,
  easing: 'ease-out',
  // Respect reduced-motion — no animation at all. Honours both the OS
  // `prefers-reduced-motion` query and the site's own `.reduce-motion` toggle
  // (accessibility overlay quiet mode, src/js/accessibility.js). `disable` is
  // evaluated at init, so accessibility must run first — see main.js import order.
  disable: () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    document.body.classList.contains('reduce-motion'),
})

// Lazysizes swaps in images and changes element heights after init, which
// shifts every trigger point below them. Recalculate once layout settles.
let refreshScheduled = false
const scheduleRefresh = () => {
  if (refreshScheduled) return
  refreshScheduled = true
  requestAnimationFrame(() => {
    refreshScheduled = false
    AOS.refresh()
  })
}

window.addEventListener('load', scheduleRefresh)
document.addEventListener('lazyloaded', scheduleRefresh)
